import React from 'react';
import { Row, Col, Button } from 'antd';
import { BiUser, BiBook, BiBuilding, BiCategory } from 'react-icons/bi';

const searchOptions = [
  { key: 'author', label: 'Author', icon: <BiUser size={16} className="me-1" /> },
  { key: 'publisher', label: 'Publisher', icon: <BiBuilding size={16} className="me-1" /> },
  { key: 'department', label: 'Department', icon: <BiBook size={16} className="me-1" /> },
  { key: 'category', label: 'Category', icon: <BiCategory size={16} className="me-1" /> }
];

const SearchOptions = ({ onSelect }) => (
  <div className="search-options-container">
    <Row 
      gutter={[8, 8]} 
      className="justify-content-center"
      style={{ maxWidth: '600px', margin: '0 auto' }}
    >
      {searchOptions.map(opt => (
        <Col 
          key={opt.key} 
          xs={12} 
          sm={6} 
          className="d-flex justify-content-center px-1"
        >
          <Button
            type="default"
            shape="round"
            className="search-opt-btn w-100 d-flex align-items-center justify-content-center"
            style={{ 
              fontWeight: 500, 
              fontSize: '0.8rem', 
              borderRadius: '8px', 
              height: 'auto',
              minHeight: '36px',
              padding: '6px 12px',
              whiteSpace: 'normal',
              lineHeight: '1.2',
              textAlign: 'center',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
            onClick={() => onSelect(opt.key)}
            icon={React.cloneElement(opt.icon, { 
              style: { 
                margin: 0,
                marginRight: '6px',
                fontSize: '1.1rem',
                flexShrink: 0
              } 
            })}
          >
            <span style={{ 
              fontSize: '0.8rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              display: 'inline-block'
            }}>
              {opt.label}
            </span>
          </Button>
        </Col>
      ))}
    </Row>
  </div>
);

export default SearchOptions;
